<template lang="html">
    <div class="main-container">
        <btn text="Professional Tax" type="primary" v-on:click="goToProfessionalTax" class="overlay"/>
        <under-construction></under-construction>
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  mounted() {
    //console.log("Professional Tax component mounted.");
  },
  methods: {
    goToProfessionalTax() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/settings/utilities/professional_tax`
      });
    },
  }
};
</script>

<style lang="scss">
.flex-box {
  display: flex;
  flex-direction: row;
  .btn {
    margin-right: 10px;
  }
}

.overlay {
  position: absolute;
}

</style>
